import { GridType, GridTypes } from '@shared/models/grid-type.model';

export const currentPage = 0;

export enum PageProductsLoad {
    GRID_16 = 48,
    GRID_4 = 20,
    ZARA_STUDIO = 10,
}

export enum SeparatorHiddenGridElements {
    SEPARATOR_12_5 = 'SEPARATOR_12_5',
    SEPARATOR_25 = 'SEPARATOR_25',
    SEPARATOR_50 = 'SEPARATOR_50',
    SEPARATOR_SM = 'SEPARATOR_SM',
    SEPARATOR_MD = 'SEPARATOR_MD',
    SEPARATOR_LG = 'SEPARATOR_LG',
    SEPARATOR_XL = 'SEPARATOR_XL',
}

export const gridTypeToNumberOfProducts: Record<GridTypes, number> = {
    [GridTypes.ZARA_STUDIO]: 2,
    [GridTypes.GRID_4]: 4,
    [GridTypes.GRID_16]: 12,
    [GridTypes.RELATEDS]: 5,
    [GridTypes.SEARCH]: 6,
};

export interface GridElement {
    template: string;
    ccIds: number[];
    hiddenFieldsByProduct: Array<{ name: string; productId: string[] }>;
    style: GridProductStyle;
    commercialComponentIds: commercialComponent[];
}

export interface commercialComponent {
    ccId: number;
    defaultImageType: string;

    // Por ahora no utilizamos estos campos
    hiddenFields?: any;
    isAddToCartDisabled?: boolean;
    kind?: 'Wear' | 'Group' | 'Marketing';
    type?: 'Product' | 'Bundle';
    mediaCompete?: any[];
}
export interface CategoryGrid {
    gridType?: GridType;
    gridDefault: GridDefault;
    gridStudio: GridStudio;
    gridNewCollection: GridNonDefault;
    totalQuantityProducts: number;
    categoryId: string;
}

export interface GridDefault {
    totalPagesIds: number; // Total de paginas a visualizar
    idsFiltered: number[]; // Total de Ids a mostrar en la grid
    pageProductIds: number[]; // Paginación de Productos, se irá rellenando con scroll
    currentPage: number;
    productsFullyLoaded?: boolean;
}

export interface GridStudio {
    totalPagesGridElements: number; // Total de paginas a visualizar
    gridElementsFiltered: GridElement[]; // Total de Templates a mostrar en la grid
    pageGridElements: GridElement[]; // Paginación de Templates, se irá rellenando con scroll
    currentPage: number;
}

export interface GridNonDefault {
    default: GridDefault;
    studio: GridStudio;
    title?: string;
}

export interface GridProductStyle {
    tintColor: string; backgroundColor: string;
}

export const SizesToFilter: string[] = ['SIZE_XS', 'SIZE_S', 'SIZE_M', 'SIZE_L', 'SIZE_XL', 'SIZE_XXL'];

export interface NewCollectionCmsConfig {
    IdDestiny: number;
    IdOrigin: string[];
    TITLE: string;
}

export interface CategoriesGridStyle {
    ID: number[];
    STYLE: CategoryGridStyle;
}

export interface CategoryGridStyle {
    backgroundColor: string;
    fontColor: string;
    oldPrice: string;
    offerPrice: string;
    colorSelector: string;
}
